export const RECENTLY_VIEWED_STORAGE = { PATH: 'recentlyViewedVins', MAX_COUNT: 50 };
